<template>
    <div class=''>
        <template v-if="dataType">
            <v-tabs class="tabs-box" centered size="large" :value="defaultActiveKey" @change="tabsChange">
                <v-tab key="0"> {{$t('account.hardware.bind')}}</v-tab>
                <v-tab key="1">{{$t('account.hardware.unbindTabs')}}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="defaultActiveKey">
                <v-tab-item :key="0">
                    <v-form
                        class="device-box mb-6"
                        ref="deviceForm">
                        <v-text-field
                            v-model="deviceForm.deviceName"
                            :rules="rules1"
                            outlined
                            hide-details="auto"
                            required
                            :label="$t('account.FIDOU2F.deviceName')"
                            min-height="36"
                            dense
                            color="#5066e0"
                            class="code-box"
                            :placeholder="$t('account.FIDOU2F.devicePlaceholder')"
                        ></v-text-field>
                    </v-form>
                    <div class="tab-boxss">
                        <div class="text">
                            {{$t('account.FIDOU2F.device')}}
                        </div>
                        <div class="btn-box">
                            <v-btn small :color="!isSupportWebAuthn ? '' : 'primary'" :disabled="!isSupportWebAuthn"  :style="{'color': bindStatus ? '#1CD66D' : '#fff'}" @click="bindFun">{{bindText}}</v-btn>
                            <v-btn small outlined class="close_btn"  @click="close">{{$t('btn.close')}}</v-btn>
                        </div>
                    </div>
                </v-tab-item>
                <v-tab-item :key="1">
                    <v-form
                        class="device-box mb-6"
                        ref="unbindForm">
                        <v-select
                            :items="tokenList"
                            v-model="unbindFormData.tokenName"
                            :menu-props="{ bottom: true, offsetY: true }"
                            outlined
                            dense
                            class="mb-8"
                            :rules="rules.tokenName"
                            :label="$t('account.FIDOU2F.deviceName')"
                            :placeholder="$t('account.FIDOU2F.selectName')"
                            hide-details="auto"
                        ></v-select>

                        <v-text-field
                            v-model="dataList.mobile"
                            :value="dataList.mobile"
                            outlined
                            hide-details="auto"
                            required
                            :label="$t('account.pghoess')"
                            min-height="46"
                            dense
                            color="#5066e0"
                            class="code-box mb-8"
                            disabled
                        ></v-text-field>

                        <v-row no-gutters class="mb-8">
                            <v-col cols="7" md="7" lg="7" xl="8" sm="12">
                                <v-text-field
                                    v-model="unbindFormData.unbindCode"
                                    :rules="rules.unbindCode"
                                    outlined
                                    :label="$t('account.code')"
                                    hide-details="auto"
                                    required
                                    dense
                                    min-height="46"
                                    color="#5066e0"
                                    class="code-box"
                                    :placeholder="$t('account.codePlaceholder')"
                                ></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="4" md="4" lg="4" xl="3" sm="12" class="code-box  ml-1 d-flex justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                                <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                                <v-btn small outlined v-else style="width:100%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                            </v-col>
                        </v-row>
                        <div class="text-center">
                            <v-btn small color="primary" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
                            <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                        </div>
                    </v-form>
                </v-tab-item>
            </v-tabs-items>
        </template>
        <template v-else>
            <v-form
                class="device-box mb-6"
                ref="deviceForm">
                <v-text-field
                    v-model="deviceForm.deviceName"
                    :rules="rules1"
                    outlined
                    hide-details="auto"
                    required
                    dense
                    :label="$t('account.FIDOU2F.deviceName')"
                    min-height="36"
                    color="#5066e0"
                    class="code-box input-style"
                    :placeholder="$t('account.FIDOU2F.devicePlaceholder')"
                ></v-text-field>
            </v-form>
            <div class="tab-boxss">
                <div class="text">
                    {{$t('account.FIDOU2F.device')}}
                </div>
                <!-- <div class="bind-box">
                    <span @click="bindFun" :style="{'color': bindStatus ? '#1CD66D' : '#5066e0'}">{{bindText}}</span>
                </div> -->
                <div class="btn-box">
                    <v-btn small :color="!isSupportWebAuthn ? '' : 'primary'" :disabled="!isSupportWebAuthn"  @click="bindFun" :style="{'color': bindStatus ? '#1CD66D' : '#fff'}">{{bindText}}</v-btn>
                    <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import { smsReset, u2fRegisterStart, u2fRegisterConfirm, u2fUnbind, getU2fToken } from "@/api/index";
import { base64urlEncode, base64urlDecode } from '@/utils/base64url-arraybuffer'
import store from '@/store'

export default {
    data() {
        return {
            form: {},
            rules: {
                tokenName: [
                    v => !!v || this.$t('account.FIDOU2F.selectName'),
                ],
                unbindCode: [
                    v => !!v || this.$t('account.codePlaceholder'),
                    v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')

                ],
            },
            rules1: [
                v => !!v || this.$t('account.FIDOU2F.devicePlaceholder'),
                v => (v && v.length <= 32) || this.$t('account.FIDOU2F.device32')
            ],
          isSupportWebAuthn:true,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            defaultActiveKey: "0",
            unbindFormData: {},
            codeText: this.$t('account.getCode'),
            spinning: false,
            tokenList: [],
            bindStatus: false,
            bindText: this.$t('account.FIDOU2F.bind'),
            deviceForm: {}
        };
    },
    mounted() {
        this.$root.eventHub.$on('handleCancel8', ()=> {
            // this.$refs.hardwareForm.resetValidation();
            this.$root.eventHub.$off("handleCancel8")
        })
    },
    created() {
        this.detectWebAuthnSupport()
        // this.getTokenList()
        if (this.dataType) {
            this.getList()

        }
    },
    props: {
        dataType: Boolean,
        dataList: Object
    },
    methods: {
      detectWebAuthnSupport() {

          console.log(window.location.protocol)
          if (window.location.protocol === "http:"){
           let  errorMessage = this.$t('account.webAuthn.nonsupportMsg')
            this.isSupportWebAuthn = false

            store.dispatch('snackbar/openSnackbar',{
              snackbarText: errorMessage,
              colorType: 'error'
            })
          }
      },
        getList() {
            getU2fToken().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.tokenList = res.data
                }
            })
        },
        onSubmit() {
            if (this.$refs.unbindForm.validate()) {
                u2fUnbind({
                    code: this.unbindFormData.unbindCode,
                    tokenName: this.unbindFormData.tokenName
                }).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.$emit("onSubmit")
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: err.message,
						colorType: 'error'
					})
                })

            } else {
                return false;
            }
        },
        close() {
            this.$emit("close")
        },
        tabsChange(e) {
            console.log(e)
            if(e == 1 && !this.dataList.mobile) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: this.$t('account.noPhone'),
                    colorType: 'error'
                })
                return;
            }
            this.defaultActiveKey = e
        },
        getCode() {
            if(this.codeText == this.$t('account.getCode')) {
                this.spinning = true
                let params = {
                    smsType: this.$getSmsModel('unbindU2f')
                }
                smsReset(params).then(res=> {
                    this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.codeText = 60
                        let timer = setInterval(()=>{
                            this.codeText--
                            if(this.codeText <= 0) {
                                clearInterval(timer)
                                this.codeText = this.$t('account.getCode')
                            }
                        },1000)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    this.spinning = false
                })
            }
        },
        bindFun() {
            let self = this
            if (this.$refs.deviceForm.validate()) {
                u2fRegisterStart({
                    tokenName: this.deviceForm.deviceName
                }).then(apiResponseData=> {
                    if (apiResponseData.code == self.$GLOBA.StatusOK) {
                        return new Promise(function(resolve, reject) {
                            if (apiResponseData.data.code != 0) {
                                store.dispatch('snackbar/openSnackbar',{
                                    snackbarText: apiResponseData.data.msg,
                                    colorType: 'error'
                                })
                            } else {
                                var returnInfo = {};
                                var businessData = apiResponseData.data
                                var reqid = businessData.reqid;
                                var fido2_data = businessData.fido2_data;

                                var makeCredentialOptions = {};
                                // Required apiResponseData
                                makeCredentialOptions.rp = fido2_data.rp;
                                makeCredentialOptions.user = fido2_data.user;
                                makeCredentialOptions.user.id = base64urlDecode(fido2_data.user.id);
                                makeCredentialOptions.challenge = base64urlDecode(fido2_data.challenge);
                                makeCredentialOptions.pubKeyCredParams = fido2_data.pubKeyCredParams;

                                // Optional apiResponseData
                                if ('timeout' in fido2_data) {
                                    makeCredentialOptions.timeout = fido2_data.timeout;
                                }
                                if ('excludeCredentials' in fido2_data) {
                                    makeCredentialOptions.excludeCredentials = self.credentialListConversion(fido2_data.excludeCredentials);
                                }
                                if ('authenticatorSelection' in fido2_data) {
                                    makeCredentialOptions.authenticatorSelection = fido2_data.authenticatorSelection;
                                }
                                if ('attestation' in fido2_data) {
                                    makeCredentialOptions.attestation = fido2_data.attestation;
                                }
                                if ('extensions' in fido2_data) {
                                    makeCredentialOptions.extensions = fido2_data.extensions;
                                }

                                // 检查浏览器是否支持函数navigator.credentials.create
                                if (typeof navigator.credentials.create !== "function") {
                                    store.dispatch('snackbar/openSnackbar',{
                                        snackbarText: self.$t('browser.nonsupport'),
                                        colorType: 'error'
                                    })
                                    // returnInfo.errorMsg = "Browser does not support credential creation";
                                    // resolve(returnInfo);
                                }

                                navigator.credentials.create({
                                    "publicKey": makeCredentialOptions
                                }).then(attestation=> {
                                    var registConfirmFido2Data = {};
                                    if ('id' in attestation) {
                                        registConfirmFido2Data.id = attestation.id;
                                    }
                                    if ('type' in attestation) {
                                        registConfirmFido2Data.type = attestation.type;
                                    }
                                    if ('rawId' in attestation) {
                                        registConfirmFido2Data.rawId = attestation.rawId;
                                    }

                                    if ('response' in attestation) {
                                        registConfirmFido2Data.response = {
                                            clientDataJSON: base64urlEncode(attestation.response.clientDataJSON),
                                            attestationObject: base64urlEncode(attestation.response.attestationObject)
                                        };

                                        registConfirmFido2Data.username = fido2_data.user.name;
                                        resolve(self.registConfirm(registConfirmFido2Data, reqid));
                                    } else {
                                        // returnInfo.errorMsg = "Make Credential response lacking 'response' attribute";
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.FIDOU2F.deviceErr'),
                                            colorType: 'error'
                                        })
                                        // resolve(returnInfo);
                                    }
                                }).catch(function(err) {
                                    let errs = err+""
                                    if (errs.indexOf("The operation either timed out or was not allowed") > -1 || errs.indexOf("The request is not allowed by the user agent or the platform in the current context") > -1) {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('browser.overtime'),
                                            colorType: 'error'
                                        })
                                    } else if (errs.indexOf("The user attempted to register an authenticator that contains one of the credentials already registered with the relying party") > -1 || errs.indexOf("An attempt was made to use an object that is not") > -1) {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.FIDOU2F.deviceRepetition'),
                                            colorType: 'error'
                                        })
                                    }else if (errs.indexOf("A request is already pending") > -1){
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.FIDOU2F.deviceRepetition'),
                                            colorType: 'error'
                                        })
                                    }else if (errs.indexOf("A request is already pending")){
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('browser.arouse'),
                                            colorType: 'error'
                                        })
                                    }else {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.FIDOU2F.failure')+"（"+errs+"）",
                                            colorType: 'error'
                                        })
                                    }
                                });
                            }
                        });
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: apiResponseData.message,
                            colorType: 'error'
                        })
                    }
                })
            }
        },
        registConfirm(registConfirmFido2Data, reqid) {
            u2fRegisterConfirm({
                reqId: reqid,
                u2fData: JSON.stringify(registConfirmFido2Data)
            }).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.bindStatus = true
                    this.bindText = this.$t('account.FIDOU2F.bindSuccess')
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: this.$t('account.FIDOU2F.bindSuccess'),
						colorType: 'success'
					})
                    setTimeout(()=>{
                        this.$emit("onSubmit")
                    }, 500)
                }
            })
            .catch(err=> {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: err.message,
                    colorType: 'error'
                })
            })
        },
        credentialListConversion(list) {
            var result = [];
            for (var i = 0; i < list.length; i++) {
                var credential = {};
                credential.type = list[i].type;
                credential.id = base64urlDecode(list[i].id);
                if ('transports' in list) {
                    credential.transports = list.transports;
                }
                result.push(credential);
            }
            return result;
        }
    },
}
</script>

<style lang='scss' scoped>
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.tab-box {
    text-align: center;
    padding: 0 100px;
    font-size: 15px;
    .bind-box {
        margin: 25px 0;
        span {
            cursor: pointer;
        }
    }
    .text {
        color: #999;
        font-size: 14px;
    }
}
.tab-boxss {
    text-align: center;
    // padding: 0 50px;
    font-size: 15px;
    .bind-box {
        margin: 25px 0;
        span {
            cursor: pointer;
        }
    }
    .text {
        color: #999;
        font-size: 14px;
        width: 69%;
        margin: 0 auto;
    }
}
.device-box {
    width: 75%;
    margin: 0 auto;
    padding-top: 20px;
}

::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
::v-deep .ant-btn-round{
    margin-right: 32px;
    width: 96px;
    height: 38px;
    border-radius: 6px;
    background: #5066e0;
    font-size: 18px;
}
::v-deep .ant-modal-title{
    line-height: 29px;
    margin-left: 16px;
    font-size: 18px;
}
.btn-box{
    margin: 30px 0 24px;
}
::v-deep{
    .ant-spin-container{
        // margin-top: -10px;
    }
    .ant-tabs-bar{
        border-bottom: 0;
        margin-bottom: 0;
    }
    .ant-tabs-nav-scroll{
        text-align: center;
    }
    .ant-tabs-nav .ant-tabs-tab {
        padding-top: 0;
    }
    .ant-tabs-nav .ant-tabs-tab-active{
        color: #5066e0;
        text-shadow: 0 0 0.25px currentColor;
    }
    .ant-tabs-ink-bar{
        background: #5066e0;
    }
    .ant-tabs-nav .ant-tabs-tab:hover{
        color: #5066e0;
    }
    .ant-tabs-nav-wrap {
        margin-bottom: 20px;
    }
}
// .input-style {
//     margin: 0 auto;
//     width: 65%;
//     margin-top: 15px;
// }
.v-application.theme--light .v-tabs.tabs-box {
    box-shadow: none !important
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
}
</style>
